import React from "react";

const Footer = props => (
  <>
    <section className="bg-white border-t border-gray-300 w-full h-16 bottom-0 z-[999999999]">
      <div className="2xl:container 2xl:mx-auto py-4 px-4 2xl:px-0">
        <small>Copyright WebDev.me.uk © 2024</small>
      </div>
    </section>
  </>
)

export default Footer